export enum UserRole {
  ADMIN = 'hunter-admin',
  DEV_ADMIN = 'hunter-dev-admin',
  HR = 'hunter-hr',
  DEV_HR = 'hunter-dev-hr',
  SUPER_HR = 'hunter-super-hr',
  DEV_SUPER_HR = 'hunter-dev-super-hr',
  HEAD = 'hunter-head',
  DEV_HEAD = 'hunter-dev-head',
}

export function getRolesByPermissionToFullReportView(): UserRole[] {
  return [
    UserRole.ADMIN,
    UserRole.DEV_ADMIN,
    UserRole.SUPER_HR,
    UserRole.DEV_SUPER_HR,
  ];
}
